/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_Q1Inputs */

const en_to_xml_faq_q1 = /** @type {(inputs: To_Xml_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the generated XML valid?`)
};

const ko_to_xml_faq_q1 = /** @type {(inputs: To_Xml_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성된 XML은 유효한가요?`)
};

const ja_to_xml_faq_q1 = /** @type {(inputs: To_Xml_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成されたXMLは有効ですか？`)
};

/**
* | output |
* | --- |
* | "Is the generated XML valid?" |
*
* @param {To_Xml_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_q1 = /** @type {((inputs?: To_Xml_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_q1(inputs)
	if (locale === "ko") return ko_to_xml_faq_q1(inputs)
	return ja_to_xml_faq_q1(inputs)
});